// extracted by mini-css-extract-plugin
export default {"button":"_1jKRz","wrapper":"_1HK_V","label":"_3Zux_","bubble":"_111fC"};